<ng-template #tpl>
	<ng-container *transloco="let translate">
		<ng-template #footerBtnHiddenContentTpl></ng-template>

		<ng-container *clientScreen="let isDesktop = isDesktop">
			@if (
				{
					slides: slides$ | async,
					slideIdx: slideIdx$ | async,
					activeId: activeId$ | async,
					indicatorIndex: indicatorIndex$ | async,
				};
				as vm
			) {
				@if (vm.slides?.[vm.slideIdx ?? -1]; as activeSlide) {
					<info-modal-cdk [closing]="closing" (outsideClick)="outsideClick(activeSlide)">
						<carousel-container
							#carousel
							class="h-full"
							(activeSlideChange)="onActiveSlideChange($event)"
						>
							<carousel-slides-wrapper>
								@for (slide of slides$ | async; track trackByI18n($index, slide)) {
									<carousel-slide [slideId]="slide.i18n">
										<info-modals-slide
											[videoId]="slide.videoId"
											(tutorialOpened)="done('tutorial-clicked')"
										>
											<img
												[src]="slideImageSrc(slide.imageName)"
												draggable="false"
											/>
											<ng-container ngProjectAs="[title]">
												<span
													[innerHTML]="
														translate(slide | slideTitle: i18nName)
													"
												></span>
											</ng-container>
											<span
												[innerHTML]="
													translate(slide | slideMessage: i18nName)
												"
											></span>
										</info-modals-slide>
									</carousel-slide>
								}
							</carousel-slides-wrapper>
						</carousel-container>
						<div ngProjectAs="[footer]" class="w-full flex items-center justify-center">
							@if (isDesktop) {
								<div class="flex-auto">
									<div
										class="p-3 text-m text-primary flex box-border ml-auto leading-em"
									>
										<div sameWidthText>
											@if ((vm.indicatorIndex ?? 0) > 0) {
												<button
													sameWidthTextItem="visible"
													class="flex"
													(click)="goBack(carousel)"
												>
													<i
														class="icon-chevron-large chevron-left text-em mr-0.5"
													></i>
													{{ translate('infoModals.general.back') }}
												</button>
											}
											<div sameWidthTextItem="hidden" class="flex">
												<i
													class="icon-chevron-large chevron-left text-em mr-0.5"
												></i>
												{{ translate('infoModals.general.back') }}
											</div>
										</div>
									</div>
								</div>
							}
							<div class="flex-none">
								@if (showIndicator$ | async) {
									<carousel-instagram-dots
										ngProjectAs="[footer]"
										class="slider-indicator pl-3 box-border"
										[maxActiveCount]="count$ | async"
										[count]="count$ | async"
										[index]="vm.indicatorIndex"
									></carousel-instagram-dots>
								}
							</div>
							<div class="flex-auto flex items-center justify-end">
								<div
									class="p-3 text-m text-primary flex box-border ml-auto leading-em"
								>
									@if (isLastSlide$ | async) {
										<button class="flex" (click)="done('done')">
											{{
												translate(activeSlide | slideFooter: i18nName)
													| slideFooterFallback
														: activeSlide
														: i18nName
														: translate('infoModals.general.done')
											}}
										</button>
									} @else {
										<button class="flex" (click)="goNext(carousel)">
											{{
												translate(activeSlide | slideFooter: i18nName)
													| slideFooterFallback
														: activeSlide
														: i18nName
														: translate('infoModals.general.next')
											}}
											<i
												class="icon-chevron-large chevron-right text-em ml-0.5"
											></i>
										</button>
									}
								</div>
							</div>
						</div>
						@if (activeSlide.showCross ?? true) {
							<button
								ngProjectAs="[insideModal]"
								class="p-2 top-0 right-0 flex absolute"
								(click)="done('cross')"
							>
								<i class="icon-cross fc-400"></i>
							</button>
						}
					</info-modal-cdk>
					<ng-template #nextBtnTpl>
						<button class="flex" (click)="goNext(carousel)">
							{{
								translate(activeSlide | slideFooter: i18nName)
									| slideFooterFallback
										: activeSlide
										: i18nName
										: translate('infoModals.general.next')
							}}
							<i class="icon-chevron-large chevron-right text-em ml-0.5"></i>
						</button>
					</ng-template>
				}
			}
		</ng-container>
	</ng-container>
</ng-template>
